document.addEventListener("DOMContentLoaded", function () {
    // query all hospot

    var hotspots = document.querySelectorAll(".hotspot__banner__hotspot-dot");

    // loop through all hotspots

    hotspots.forEach(function (hotspot) {
        const targetContent = hotspot.getAttribute("data-target-content");
        const contentEl = document.getElementById(targetContent);
        // mouse enter event

        if (!contentEl) return;

        if (window.innerWidth < 1024) {
            hotspot.addEventListener("click", function () {
                contentEl.classList.toggle("invisible");
            });
        } else {
            hotspot.addEventListener("mouseenter", function () {
                contentEl.classList.remove("invisible");
            });

            // mouse leave event

            hotspot.addEventListener("mouseleave", function () {
                contentEl.classList.add("invisible");
            });
        }
    });
});
